import { Flex, Input, Modal, message } from 'antd';
import { FC, useEffect, useState } from 'react';
import { StagesDataType } from '../../../../ types';
import { StagesStore } from '../../../../../DataSource/Stores/Cabinet/StagesStore';
import IconButton from '../../../../ui/IconButton';
import StageDrawer from '../../../StageDrawer';
import * as styles from './index.module.scss';

const Column: FC<StagesDataType> = ({ _id, name }) => {
  const [password, setPassword] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    setPassword('');
  }, [modalOpen]);

  const handlePassword = () => {
    //защита от дураков
    if (password !== '112255') {
      message.error('Неверный пароль');
      return;
    }
    setModalOpen(false);
    setDrawerOpen(true);
  };

  const stage = StagesStore.dataList.find((stage) => stage._id === _id);

  return (
    <>
      <div className={styles.column}>
        <div className={styles.columnTop}>
          <Flex align="center" gap={8}>
            <IconButton
              className={styles.settingsBtn}
              icon="cog"
              variant="clear"
              onClick={() => setModalOpen(true)}
            />
            <p className={styles.name}>{name}</p>
          </Flex>
          <p className={styles.amount}>
            {StagesStore.dataJobsList?.filter((job) => job.stageId === _id).length}
          </p>
        </div>
      </div>

      <Modal
        closable={false}
        open={modalOpen}
        onOk={handlePassword}
        onCancel={() => setModalOpen(false)}
      >
        <Input
          placeholder="Пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </Modal>

      {stage && <StageDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} {...stage} />}
    </>
  );
};

export default Column;
